module.exports = __webpack_public_path__ + "img/20.99244daf.jpg";